import { ChakraProvider, ColorModeScript } from "@chakra-ui/react"
import * as React from "react"
import * as ReactDOM from "react-dom/client"
import { App } from "./App"
import reportWebVitals from "./reportWebVitals"
import { BrowserRouter, Routes, Route } from "react-router";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import "./fonts.css";

import { DeepAuth } from "./features/auth/DeepAuth"
import { deepTheme } from "theme"
import { GoogleOAuthProvider } from '@react-oauth/google';
import ReactGA from "react-ga4";
import { ModalProvider } from "components/ModalHost"

ReactGA.initialize("G-M9WTY1HYMW");

const container = document.getElementById("root")
if (!container) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(container)

//<React.StrictMode>
root.render(
	<GoogleOAuthProvider clientId="708348768986-lbeui93sidi73ku6jbflbdf2pckr3gf3.apps.googleusercontent.com">
		<ChakraProvider theme={deepTheme} toastOptions={{ defaultOptions: { position: "bottom-right" } }}>
			<BrowserRouter>
				<ColorModeScript />
				{/*<ModalProvider>*/}
				<DeepAuth>
					<App />
				</DeepAuth>
				{/*</ModalProvider>*/}
			</BrowserRouter>
		</ChakraProvider>
	</GoogleOAuthProvider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

